export default {"src":"/_next/static/media/0x1f9840a85d5af5bf1d1762f925bdaddc4201f984.f2b8cf86.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};